import Plugin, { init } from "@/modules/_utils/Plugin";
import Swiper from "swiper";

export default () => {
  const homeSlider = new Swiper("#home__swiper-container", {
    effect: "fade",
    simulateTouch: true,
    preloadImages: false,
    autoplay: {
      delay: 10000,
      disableOnInteraction: false
    },
    lazy: {
      loadPrevNext: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: false,
      renderBullet: function(index, className) {
        return '<span class="' + className + '"></span>';
      }
    },
    on: {
      init: function() {},
      lazyImageReady: function() {
        document.getElementById("home__slider").classList.add("swiper-init");
      }
    }
  });
};
